import Index from './System'
import IndexHeading from './IndexHeading'
import Commodities from './Commodities'
import CommoditiesHeading from './CommoditiesHeading'
import PublicJob from './PublicJob'
import PublicJobHeading from './PublicJobHeading'
import Xero from './Xero'
import XeroHeading from './XeroHeading'

export default {
  Index,
  IndexHeading,
  Commodities,
  CommoditiesHeading,
  PublicJob,
  PublicJobHeading,
  Xero,
  XeroHeading
}



// WEBPACK FOOTER //
// ./src/components/settings/system/index.js